export default __webpack_public_path__ + "4b4c6d1520347383f48a825c4d3410b9.svg";